import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationDialogModule } from './components';
import { MaskDateDirective } from './directives/mask-date.directive';
import { SharedComponent } from './shared.component';

const defaultModules = [
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgxSpinnerModule,
  ConfirmationDialogModule,
]

@NgModule({
  declarations: [
    SharedComponent,
    MaskDateDirective,
  ],
  imports: [
    
  ],
  exports: [
    SharedComponent,
    defaultModules,
    MaskDateDirective
  ]
})
export class SharedModule { }
